import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "it", setLang: () => {} });

export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("site-lang") || "it");

  const setLang = (l) => {
    localStorage.setItem("site-lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}
